import {
  http,
  delayIt,
} from '../utils/http';
import axios from "axios";
import {
  layoutConfig
} from '../utils/mockData.js';

const CancelToken = axios.CancelToken;

export const StatusTypeListUrl = '/api/common/flow-status-list';

export const ApplyTypeUrl = 'api/fas/payment/apply-type';

export const ApplyPersonUrl = 'api/oa/common/applied-user';

export const printUrl = '/api/oa/payment/pdf/';

export function getSearchOptions(url, params) {
  return http.get(url, {
    params
  });
}

export function getLayoutApi(params) {
  return http.get('/api/fas/payment/form?type=create', {
    params
  });
}

export function getLayoutDetailApi(params) {
  return http.get('/api/fas/payment/form?type=detail', {
    params
  });
}

export function getCommonLayoutDetailApi(params) {
  return http.get(`/api/fe/oa/usual/form/${params.id}?type=detail`, {
    params
  });
}

export function getPaymentDetail(params) {
  return http.get('/api/fas/payment/info', {
    params
  });
}

export function getCommonDetail(params) {
  return http.get(`/api/fe/oa/usual/info/${params.id}`, {
    params
  });
}

export function createPayment(params) {
  return http.post('/api/fas/payment/create', params);
}

// 付款审批流
export function getApprovalFlow(params, config) {
  return http.post('/api/fas/payment/flow', params, {
    cancelToken: new CancelToken(function executor(c) {
      config.cancelSource = c;
    })
  });
}

export function approvalApplication(params) {
  return http.post('/api/oa/update-progress', params);
}

export function commonApplication(params) {
  return http.post('/api/fe/oa/usual/flow', params);
}

export function uploadApi(params) {
  return http.post('/api/oa/upload-attachment-file', params);
}
// 付款详情页审批流
export function getDetailApprovalFlow(params) {
  return http.post('/api/fas/payment/flow-history', params);
}

export function getDetailCommonFlow(params) {
  return http.get(`/api/fe/oa/usual/flow/${params.id}`, {
    params
  });
}

// 打印接口
export function getBlueWhaleKey(params) {
  return http.post('/api/oa/get-blue-whale-key', params)
}

export function downloadBankElectron(params) {
  return http.get('/api/oa/download-bank-electron', {
    params
  })
}

export function getLoginUrl(params) {
  return http.post('/api/oa/get-login-url', params)
}

// 获取报销单整体表单
export function reimburseBaseLayout(params) {
  if(0) {
    return delayIt(() => {
      return {
        status: 'success',
        data: {
          "pageTitle": "新建报销申请",
          "introduction": [],
          "contents": [
            {
              "field": "basicInfo",
              "type": "commonForm",
              "contents": [
                {
                  "label": "申请人",
                  "field": "applier_id",
                  "type": "text",
                  "show": true
                },
                {
                  "label": "报销单类型",
                  "field": "type",
                  "type": "select",
                  "show": true,
                  "fetch": {
                    "url": "api/fas/reimburse/reimburse-form-type-options"
                  },
                  "eventRelays": [
                    {
                      "selfDo": "emit"
                    },
                    {
                      "selfDo": "passNeighor",
                      "params": {
                        "value": "detailInfo"
                      }
                    },
                    {
                      "selfDo": "broadcast"
                    },
                    {
                      "selfDo": "refreshOptionsByField",
                      "params": {
                        "value": "type"
                      }
                    }
                  ],
                  "required": true,
                  "trigger": [
                    {
                      "target": "company_id",
                      "requirements": [
                        {
                          "name": "notInclude",
                          "params": {
                            "value": [
                              8,
                              "福利-工作餐报销"
                            ]
                          }
                        }
                      ],
                      "actions": [
                        {
                          "name": "notDisabled"
                        }
                      ]
                    },
                    {
                      "target": "company_id",
                      "requirements": [
                        {
                          "name": "include",
                          "params": {
                            "value": [
                              8,
                              "福利-工作餐报销"
                            ]
                          }
                        }
                      ],
                      "actions": [
                        {
                          "name": "disabled"
                        }
                      ]
                    }
                  ]
                },
                {
                  "label": "实际申请人",
                  "field": "actual_applier_id",
                  "type": "select",
                  "show": true,
                  "fetch": {
                    "url": "api/fas/reimburse/actual-applier-option"
                  },
                  "required": true,
                  "trigger": [
                    {
                      "target": "company_id",
                      "requirements": [
                        {
                          "name": "isTriggerDisabled"
                        }
                      ],
                      "actions": [
                        {
                          "name": "disabled"
                        }
                      ]
                    },
                    {
                      "target": "company_id",
                      "requirements": [],
                      "actions": [
                        {
                          "name": "updateValueByDriver"
                        }
                      ]
                    }
                  ]
                },
                {
                  "label": "公司信息",
                  "field": "company_id",
                  "type": "select",
                  "show": true,
                  "fetch": {
                    "url": "api/fas/payment/company-options"
                  },
                  "required": true
                },
                {
                  "label": "发票",
                  "field": "provide_invoices",
                  "type": "radio",
                  "show": true,
                  "fetch": {
                    "url": "api/fas/reimburse/provide-invoices-option"
                  },
                  "required": true
                }
              ]
            },
            {
              "field": "detailInfo",
              "type": "multiForm",
              "formTitle": "报销明细",
              "contents": [
                {
                  "label": "报销类别",
                  "field": "type",
                  "type": "select",
                  "show": true,
                  "fetch": {
                    "url": "api/fas/reimburse/reimburse-detail-type-options",
                    "depends": [
                      {
                        "type": {
                          "from": "superior",
                          "fieldPath": "basicInfo.type"
                        }
                      }
                    ]
                  },
                  "required": true,
                  "trigger": [
                    {
                      "target": "budget_subject_id",
                      "requirements": [
                        {
                          "name": "notInclude",
                          "params": {
                            "value": [
                              14,
                              "福利-工作餐费"
                            ]
                          }
                        }
                      ],
                      "actions": [
                        {
                          "name": "show"
                        }
                      ]
                    },
                    {
                      "target": "budget_subject_id",
                      "requirements": [
                        {
                          "name": "include",
                          "params": {
                            "value": [
                              14,
                              "福利-工作餐费"
                            ]
                          }
                        }
                      ],
                      "actions": [
                        {
                          "name": "hidden"
                        }
                      ]
                    },
                    {
                      "target": "money",
                      "requirements": [
                        {
                          "name": "notInclude",
                          "params": {
                            "value": [
                              14,
                              "福利-工作餐费"
                            ]
                          }
                        }
                      ],
                      "actions": [
                        {
                          "name": "notDisabled"
                        }
                      ]
                    },
                    {
                      "target": "money",
                      "requirements": [
                        {
                          "name": "include",
                          "params": {
                            "value": [
                              14,
                              "福利-工作餐费"
                            ]
                          }
                        }
                      ],
                      "actions": [
                        {
                          "name": "disabled"
                        }
                      ]
                    }
                  ]
                },
                {
                  "label": "业务目的",
                  "field": "business_purpose",
                  "type": "input",
                  "show": true,
                  "placeholder": "请填写业务目的（必填）",
                  "maxLength": 100,
                  "required": true
                },
                {
                  "label": "备注",
                  "field": "remarks",
                  "type": "textArea",
                  "show": true,
                  "placeholder": "请填写备注信息（选填）",
                  "maxLength": 100
                },
                {
                  "label": "报销金额(元)",
                  "field": "money",
                  "type": "number",
                  "show": true,
                  "placeholder": "请填写报销金额（必填）",
                  "required": true
                },
                {
                  "label": "预算科目",
                  "field": "budget_subject_id",
                  "type": "select",
                  "show": true,
                  "fetch": {
                    "url": "api/fas/reimburse/budget-subject-option",
                    "depends": [
                      {
                        "type": {
                          "from": "superior",
                          "fieldPath": "basicInfo.type"
                        }
                      }
                    ]
                  },
                  "disabled": false,
                  "required": true
                },
                {
                  "label": "发票日期",
                  "field": "invoice_date",
                  "type": "datePicker",
                  "show": true,
                  "placeholder": "请选择日期",
                  "init": [
                    {
                      "type": "month",
                      "number": -6,
                      "message": "根据费用报销制度规定发票超过6个月的不予报销"
                    }
                  ],
                  "compare": {
                    "type": "day",
                    "number": -89,
                    "message": "日期已超过90天,超期报销请单独提交报销申请"
                  },
                  "required": true
                },
                {
                  "label": "发票类型",
                  "field": "invoice_type",
                  "type": "radio",
                  "show": true,
                  "fetch": {
                    "url": "api/fas/reimburse/invoice-type-option",
                    "depends": [
                      {
                        "type": {
                          "from": "same"
                        }
                      }
                    ]
                  },
                  "required": true,
                  "trigger": [
                    {
                      "target": "tax_rate",
                      "requirements": [
                        {
                          "name": "include",
                          "params": {
                            "value": [
                              1,
                              "增值税专用发票"
                            ]
                          }
                        }
                      ],
                      "actions": [
                        {
                          "name": "show"
                        }
                      ]
                    },
                    {
                      "target": "tax_rate",
                      "requirements": [
                        {
                          "name": "include",
                          "params": {
                            "value": [
                              2,
                              "增值税普通发票"
                            ]
                          }
                        },
                        {
                          "name": "notInclude",
                          "isCheckDependParams": true,
                          "dependParams": "type",
                          "params": {
                            "value": [
                              13,
                              "本地交通费",
                              62,
                              "私车公用费-DTP"
                            ]
                          }
                        }
                      ],
                      "actions": [
                        {
                          "name": "hidden"
                        }
                      ]
                    },
                    {
                      "target": "tax_rate",
                      "requirements": [
                        {
                          "name": "include",
                          "params": {
                            "value": [
                              2,
                              "增值税普通发票"
                            ]
                          }
                        },
                        {
                          "name": "include",
                          "isCheckDependParams": true,
                          "dependParams": "type",
                          "params": {
                            "value": [
                              13,
                              "本地交通费",
                              62,
                              "私车公用费-DTP"
                            ]
                          }
                        }
                      ],
                      "actions": [
                        {
                          "name": "show"
                        }
                      ]
                    }
                  ]
                },
                {
                  "label": "税率",
                  "field": "tax_rate",
                  "type": "radio",
                  "show": true,
                  "fetch": {
                    "url": "api/fas/reimburse/tax-rate-option",
                    "depends": [
                      {
                        "type": {
                          "from": "same"
                        }
                      }
                    ]
                  },
                  "required": true
                }
              ]
            },
            {
              "field": "summationInfo",
              "type": "summation",
              "contents": [
                {
                  "label": "总报销金额(元)",
                  "field": "total_pay",
                  "type": "text",
                  "show": true,
                  "dependsParams": "money"
                }
              ]
            },
            {
              "label": "附件",
              "type": "upload",
              "field": "attachment",
              "options": []
            }
          ]
        }
      }
    })
  }
  return http.get('/api/fas/reimburse/reimburse-base-form', {
    params
  })
}
export function reimburseDetailLayout(params) {
  if(0) {
    return delayIt(() => {
      return {
        status: 'success',
        data: [
          {
            "label": "报销类别",
            "field": "type",
            "type": "select",
            "show": true,
            "fetch": {
              "url": "api/fas/reimburse/reimburse-detail-type-options",
              "depends": [
                {
                  "type": {
                    "from": "superior",
                    "fieldPath": "basicInfo.type"
                  }
                }
              ]
            },
            "required": true,
            "trigger": [
              {
                "target": "budget_subject_id",
                "requirements": [
                  {
                    "name": "notInclude",
                    "params": {
                      "value": [
                        14,
                        "福利-工作餐费"
                      ]
                    }
                  }
                ],
                "actions": [
                  {
                    "name": "show"
                  }
                ]
              },
              {
                "target": "budget_subject_id",
                "requirements": [
                  {
                    "name": "include",
                    "params": {
                      "value": [
                        14,
                        "福利-工作餐费"
                      ]
                    }
                  }
                ],
                "actions": [
                  {
                    "name": "hidden"
                  }
                ]
              },
              {
                "target": "money",
                "requirements": [
                  {
                    "name": "notInclude",
                    "params": {
                      "value": [
                        14,
                        "福利-工作餐费"
                      ]
                    }
                  }
                ],
                "actions": [
                  {
                    "name": "notDisabled"
                  }
                ]
              },
              {
                "target": "money",
                "requirements": [
                  {
                    "name": "include",
                    "params": {
                      "value": [
                        14,
                        "福利-工作餐费"
                      ]
                    }
                  }
                ],
                "actions": [
                  {
                    "name": "disabled"
                  }
                ]
              }
            ]
          },
          {
            "label": "业务目的",
            "field": "business_purpose",
            "type": "input",
            "show": true,
            "placeholder": "请填写业务目的（必填）",
            "maxLength": 100,
            "required": true
          },
          {
            "label": "备注",
            "field": "remarks",
            "type": "textArea",
            "show": true,
            "placeholder": "请填写备注信息（选填）",
            "maxLength": 100
          },
          {
            "label": "报销金额(元)",
            "field": "money",
            "type": "number",
            "show": true,
            "placeholder": "请填写报销金额（必填）",
            "required": true
          },
          {
            "label": "预算科目",
            "field": "budget_subject_id",
            "type": "select",
            "show": true,
            "fetch": {
              "url": "api/fas/reimburse/budget-subject-option",
              "depends": [
                {
                  "type": {
                    "from": "superior",
                    "fieldPath": "basicInfo.type"
                  }
                }
              ]
            },
            "disabled": false,
            "required": true
          },
          {
            "label": "发票日期",
            "field": "invoice_date",
            "type": "datePicker",
            "show": true,
            "placeholder": "请选择日期",
            "init": [
              {
                "type": "month",
                "number": -6,
                "message": "根据费用报销制度规定发票超过6个月的不予报销"
              }
            ],
            "compare": {
              "type": "day",
              "number": -89,
              "message": "日期已超过90天,超期报销请单独提交报销申请"
            },
            "required": true
          },
          {
            "label": "发票类型",
            "field": "invoice_type",
            "type": "radio",
            "show": true,
            "fetch": {
              "url": "api/fas/reimburse/invoice-type-option",
              "depends": [
                {
                  "type": {
                    "from": "same"
                  }
                }
              ]
            },
            "required": true,
            "trigger": [
              {
                "target": "tax_rate",
                "requirements": [
                  {
                    "name": "include",
                    "params": {
                      "value": [
                        1,
                        "增值税专用发票"
                      ]
                    }
                  }
                ],
                "actions": [
                  {
                    "name": "show"
                  }
                ]
              },
              {
                "target": "tax_rate",
                "requirements": [
                  {
                    "name": "include",
                    "params": {
                      "value": [
                        2,
                        "增值税普通发票"
                      ]
                    }
                  },
                  {
                    "name": "notInclude",
                    "isCheckDependParams": true,
                    "dependParams": "type",
                    "params": {
                      "value": [
                        13,
                        "本地交通费",
                        62,
                        "私车公用费-DTP"
                      ]
                    }
                  }
                ],
                "actions": [
                  {
                    "name": "hidden"
                  }
                ]
              },
              {
                "target": "tax_rate",
                "requirements": [
                  {
                    "name": "include",
                    "params": {
                      "value": [
                        2,
                        "增值税普通发票"
                      ]
                    }
                  },
                  {
                    "name": "include",
                    "isCheckDependParams": true,
                    "dependParams": "type",
                    "params": {
                      "value": [
                        13,
                        "本地交通费",
                        62,
                        "私车公用费-DTP"
                      ]
                    }
                  }
                ],
                "actions": [
                  {
                    "name": "show"
                  }
                ]
              }
            ]
          },
          {
            "label": "税率",
            "field": "tax_rate",
            "type": "radio",
            "show": true,
            "fetch": {
              "url": "api/fas/reimburse/tax-rate-option",
              "depends": [
                {
                  "type": {
                    "from": "same"
                  }
                }
              ]
            },
            "required": true
          }
        ]
        
      }
    })
  }
  return http.get('/api/fas/reimburse/reimburse-detail-form', {
    params
  })
}
export function reimburseCreateInfo(params) {
  return http.get('/api/fas/reimburse/create', {
    params
  });
}
// 报销提交
export function submitReimburse(params) {
  return http.post('/api/fas/reimburse', params);
}

// 创建报销审批流
export function getReimburseApprovalFlow(params, config) {
  return http.post('/api/fas/reimburse/flow', params, {
    cancelToken: new CancelToken(function executor(c) {
      config.cancelSource = c;
    })
  });
}

// 报销详情审批流
export function getReimburseDetailApprovalFlow(params) {
  return http.post('/api/fas/reimburse/flow-history', params);
}

//报销申请详情信息
export function getReimburseDetailInfo(id, params) {
  return http.get(`/api/fas/reimburse/${id}`, {
    params
  });
}
//报销复制或修改获取详情信息
export function editReimburseDetailInfo(id, params) {
  return http.get(`/api/fas/reimburse/${id}/edit`, {
    params
  });
}
// 报销单审批状态变更
export function updateReimburseApplication(params) {
  return http.post('/api/oa/update-reimburse-progress', params);
}

//应用权限
export function getApplicationPermissions() {
  return http.get('api/oa/get-permission');
}

/*
 项目支出付款
 */
// 项目支出付款表单布局
export function getProPaymentLayout(params) {
  return http.get('/api/fas/project-payment/form', {
    params
  })
}
// 项目支出付款创建时获取默认值/缓存值
export function getCreateProPaymentParams(params) {
  return http.get('/api/fas/project-payment/create', {
    params
  })
}
// 项目支出付款修改或复制详情
export function getProPaymentEditParams(id) {
  return http.get(`/api/fas/project-payment/${id}/edit`)
}
// 项目支出发票附件上传接口
export function commonFromUploadApi(url, params) {
  return http.post(url, params);
}
// 项目支出付款提交
export function submitProPayment(params) {
  return http.post('/api/fas/project-payment', params);
}
// 查看项目支出付款详情
export function getProPaymentDetail(id, params) {
  return http.get(`/api/fas/project-payment/${id}`, {
    params
  })
}
//修改项目支出付款申请
export function updateProPayment(id, params) {
  return http.put(`/api/fas/project-payment/${id}`, params)
}
// 创建项目付款审批流
export function getProPaymentFlow(params, config) {
  return http.post('/api/fas/project-payment/flow', params, {
    cancelToken: new CancelToken(function executor(c) {
      config.cancelSource = c;
    })
  });
}
//项目付款详情审批流
export function getProPaymentDetailFlow(params) {
  return http.post('/api/fas/project-payment/flow-history', params);
}
/*
 项目支出报销
 */
// 项目支出报销表单布局
export function getProReimburseLayout(params) {
  return http.get('/api/fas/project-reimburse/form', {
    params
  })
}
// 项目支出报销表单明细字段
export function getProReimburseDetailLayout(params) {
  return http.get('/api/fas/project-reimburse/form-detail', {
    params
  })
}
// 项目支出报销创建时获取默认值/缓存值
export function getCreateProReimburseParams(params) {
  return http.get('/api/fas/project-reimburse/create', {
    params
  })
}
// 项目支出报销修改或复制详情
export function getProReimburseEditParams(id) {
  return http.get(`/api/fas/project-reimburse/${id}/edit`)
}
// 项目支出报销提交
export function submitProReimburse(params) {
  return http.post('/api/fas/project-reimburse', params);
}
// 查看项目支出报销详情
export function getProReimburseDetail(id, params) {
  return http.get(`/api/fas/project-reimburse/${id}`, {
    params
  })
}
//修改项目支出报销申请
export function updateProReimburse(id, params) {
  return http.put(`/api/fas/project-reimburse/${id}`, params)
}
// 创建项目报销审批流
export function getProReimburseFlow(params, config) {
  return http.post('/api/fas/project-reimburse/flow', params, {
    cancelToken: new CancelToken(function executor(c) {
      config.cancelSource = c;
    })
  });
}
//项目报销详情审批流
export function getProReimburseDetailFlow(params) {
  return http.post('/api/fas/project-reimburse/flow-history', params);
}

/*
 采购
 */
//采购表单布局
export function getPurchaseLayout(params) {
  if (0) {
    return delayIt(() => {
      return {
        status: 'success',
        data: layoutConfig,
      }
    })
  }
  return http.get('/api/fas/purchase/form', {
    params
  });
}

//新建采购默认值
export function getCreatePurchaseParams(params) {
  if (0) {
    return delayIt(() => {
      return {
        status: 'success',
        data: {
          basicInfo: {
            applicant_info: "李阳 000027 技术研发部,QA团队"
          },
          detailInfo: [{
            provide_invoices: 1
          }]
        },
      }
    })
  }
  return http.get('/api/fas/purchase/info', {
    params
  });
}

// 创建采购审批流
export function getPurchaseFlow(params, config) {
  return http.post('/api/fas/purchase/flow', params, {
    cancelToken: new CancelToken(function executor(c) {
      config.cancelSource = c;
    })
  });
}

//提交采购申请
export function submitPurchase(params) {
  return http.post('/api/fas/purchase', params);
}

//采购申请详情信息
export function getPurchaseDetailInfo(params) {
  // if (0) {
  //   return delayIt(() => {
  //     return {
  //       status: 'success',
  //       data: {
  //         basicInfo: {
  //           applicant_info: "李阳 000027 技术研发部,QA团队"
  //         },
  //         detailInfo: [{
  //           provide_invoices: 1
  //         }]
  //       },
  //     }
  //   })
  // }
  return http.get('/api/fas/purchase/detail', {
    params
  });
}

//采购申请详情审批流
export function getPurchaseDetailFlow(params) {
  return http.post('/api/fas/purchase/flow-history', params);
}

//审批采购接口
export const passPurchaseApi = '/api/fas/purchase/pass';
export const rejectPurchaseApi = '/api/fas/purchase/reject';
export function approvalPurchaseApplication(url, params) {
  return http.post(url, params);
}

//撤回采购申请
export function retreatPurchase(params) {
  return http.post('/api/fas/purchase/withdraw', params);
}

//采购缓存
export function purchaseCache(params) {
  return http.post('/api/fas/purchase/cache', params);
}

// 评论 & 抄送 start

export function getNoticeUserList(params) {
  return http.get('/api/oa/common/notice-user-list', { params });
}

export function sendComment(params) {
  return http.post('/api/oa/common/comment', params);
}

// 评论 & 抄送 end